function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.46,3.15a1.48,1.48,0,0,1,.48,1.06V27.73a1.54,1.54,0,0,1-1.54,1.53h0a1.49,1.49,0,0,1-1-.36L9.08,22.18a.53.53,0,0,0-.45-.2H6.19A3,3,0,0,1,3.24,19V13a3,3,0,0,1,2.94-2.95H8.59A.6.6,0,0,0,9,9.91l7.34-6.74A1.49,1.49,0,0,1,18.46,3.15Zm-1,1.09h0L10.09,11a2,2,0,0,1-1.54.6H6.19A1.46,1.46,0,0,0,4.74,13v6a1.47,1.47,0,0,0,1.45,1.45h2.5a2,2,0,0,1,1.44.64l7.26,6.66Zm4.31,5.29a.75.75,0,0,0-1.13,1,8.4,8.4,0,0,1,0,11,.76.76,0,0,0,.07,1.06.74.74,0,0,0,1.06-.07A9.92,9.92,0,0,0,21.75,9.53Zm3-3.72a.75.75,0,0,0-1.06,0,.75.75,0,0,0,0,1.06,13.5,13.5,0,0,1,0,18.37.75.75,0,0,0,0,1.06.71.71,0,0,0,.51.21.75.75,0,0,0,.55-.24A15,15,0,0,0,24.74,5.81Z",
  fill: "#33ba69"
});

var SvgSoundDbIcon = function SvgSoundDbIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundDbIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound_DB_icon.1e13aa91.svg";
export { ForwardRef as ReactComponent };